import React, { useEffect, useState } from "react";
import { bgrouplist, roleList, statemaster, wtypelist } from "../../../services/master";
import Select from "react-select";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { academylist, workercreate, workerdetail } from "../../../services/admin";
import { toast } from "react-toastify";

export default function Addworkers() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [wname, setWName] = useState("");
  const [empid, setEmpId] = useState("");
  const [wtype, setWType] = useState("");
  const [wlist, setWlist] = useState([]);

  const [wdob, setWDob] = useState("");

  const [wblood, setWBlood] = useState("");
  const [blist, setBlist] = useState([]);

  const [wgender, setWGender] = useState("");
  const [wphone, setWPhone] = useState("");
  const [wqual, setWQual] = useState("");
  const [wadd1, setWAdd1] = useState("");
  const [wadd2, setWAdd2] = useState("");

  const [wstate, setWState] = useState("");
  const [slist, setSlist] = useState([]);

  const [wcity, setWCity] = useState("");
  const [wdist, setWDist] = useState("");
  const [wpin, setWPin] = useState("");

  const [pfile, setPFile] = useState("");
  const [purl, setPUrl] = useState("");

  const [acchold, setAccHold] = useState("");
  const [bname, setBName] = useState("");
  const [accno, setAccno] = useState("");
  const [ifscode, setIfsCode] = useState("");
  const [bbranch, setBBranch] = useState("");

  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const location = useLocation();
  const [urllink, setUrllink] = useState("");

  const [username, setUserName] = useState("");
      const [pswd, setPswd] = useState("");

  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrllink(path);

    bgrouplist().then((res) => {
      if (res.status === true) {
        setBlist(res.data);
      }
    });

    // wtypelist().then((res) => {
    //   if (res.status === true) {
    //     setWlist(res.data);
    //   }
    // });

    roleList().then((res) => {
      if (res.status === true) {
        setWlist(res.data);
      }
    });
    statemaster().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
          setSlist(arr);
        }
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });

    if (path === "workerdetail") {
      workerdetail(id).then((res) => {
        if (res.status === true) {
          if (res.data.details !== null) {
            setAcaID(res.data.details.academy_id);
            setWName(res.data.details.worker_name);
            setEmpId(res.data.details.employee_id);
            setWType(res.data.details.type);
            setWDob(res.data.details.dob);
            setWBlood(res.data.details.blood_group);
            setWGender(res.data.details.gender);
            setWAdd1(res.data.details.address1);
            if (res.data.details.address2 !== null) {

              setWAdd2(res.data.details.address2);
            }
            if (res.data.details.qualification !== null) {
              setWQual(res.data.details.qualification);
            }
            if (res.data.details.username !== null) {
              setUserName(res.data.details.username);
            }
  
            if (res.data.password !== null) {
              setPswd(res.data.password);
            }

            statemaster().then((res1) => {
              if (res1.status === true) {
                let arr = [];
                if (res1.data.length > 0) {
                  for (let i = 0; i < res1.data.length; i++) {
                    if (res1.data[i].id === res.data.details.state) {
                      arr.push({
                        value: res1.data[i].id,
                        label: res1.data[i].name,
                      });
                    }
                  }
                  setWState(arr[0]);
                }
              }
            });
            academylist().then((response) => {
              if (response.status === true) {
                let arr = [];
                if (response.data.details.length > 0) {
                  for (let i = 0; i < response.data.details.length; i++) {
                    if (
                      response.data.details[i].id == res.data.details.academy_id
                    ) {
                      arr.push({
                        value: response.data.details[i].id,
                        label:
                          response.data.details[i].name +
                          " - " +
                          response.data.details[i].code,
                      });
                    }
                  }
                  setAcaID(arr[0]);
                }
              }
            });
            setWCity(res.data.details.city);
            setWDist(res.data.details.district);
            setWPin(res.data.details.pincode);
            setWPhone(res.data.details.phone);
            if (res.data.details.worker_photo !== "") {
              setPUrl(res.data.path + res.data.details.worker_photo);
              // setPFile(res.data.worker_photo);
            }
            if (res.data.details.bank_acc_holder !== null) {
              setAccHold(res.data.details.bank_acc_holder);
            }
            if (res.data.details.bank_name !== null) {
              setBName(res.data.details.bank_name);
            }
            if (res.data.details.bank_accno !== null) {
              setAccno(res.data.details.bank_accno);
            }
            if (res.data.details.bank_ifsc !== null) {
              setIfsCode(res.data.details.bank_ifsc);
            }
            if (res.data.details.bank_branch !== null) {
              setBBranch(res.data.details.bank_branch);
            }
          }

        }
      })
    }else{
      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
                if (arr.length > 0) {
                  setAcaID(arr[0]);
                 
                }
              }
             
            }
          }
        });
      }
    }
  }, [location.pathname]);

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
    } else {
      setAcaID("");
    }
  }

  function LetterOnly(eve) {
    if (/^[a-zA-Z\s]*$/.test(eve.key)) {
      return true;
    } else {
      eve.preventDefault();
      return false;
    }
  }

  function onPasteLetter(e) {
    const str = e.clipboardData.getData("Text");
    const newStr = str.replace(/[+-.]/g, "");
    if (str !== newStr) {
      e.preventDefault();
    }
  }

  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setWPhone(e.target.value);
    }
  };

  const handleAcc = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setAccno(e.target.value);
    }
  };

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/user.png");
    ev.target.onerror = null;
  }

  const [photoerror, setPhotoError] = useState("");
  function photofile(event) {
    setPhotoError("");
    setPFile("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
        setPUrl(URL.createObjectURL(event.target.files[0]));
        setPFile(event.target.files[0]);
      } else {
        setPhotoError("Photo should be jpg, jpeg, or png format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setPhotoError("Photo size should be less than 5MB");
      }
    }
  }

  function handleState(e) {
    if (e !== null) {
      setWState(e);
    } else {
      setWState("");
    }
  }

  const [errmsg, setErrorMsg] = useState("");
  const [successmsg, setSuccess] = useState(false);
  function submitworker(e) {
    e.preventDefault();
    setErrorMsg("");
    setSuccess(true);

    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setErrorMsg("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }

    if (
      wname !== "" &&
      empid !== "" &&
      wtype !== "" &&
      wblood !== "" &&
      wgender !== "" &&
      wphone !== "" &&
      wdob !== "" &&
      wadd1 !== "" &&
      wstate !== "" &&
      wcity !== "" &&
      wdist !== "" &&
      wpin !== "" &&
      // pfile !== "" &&
      valid === ""
    ) {
      setLoading(true);
      const temp = new FormData();
      temp.append("worker_name", wname);
      temp.append("employee_id", empid);
      temp.append("type", wtype);
      temp.append("dob", wdob);
      temp.append("blood_group", wblood);
      temp.append("gender", wgender);
      temp.append("phone", wphone);
      temp.append("qualification", wqual);
      temp.append("address1", wadd1);
      temp.append("address2", wadd2);
      temp.append("state", wstate.value);
      temp.append("district", wdist);
      temp.append("city", wcity);
      temp.append("pincode", wpin);
      temp.append("worker_photo", pfile);
      temp.append("acc_holder", acchold);
      temp.append("bank", bname);
      temp.append("accno", accno);
      temp.append("ifsc", ifscode);
      temp.append("branch", bbranch);
      if (localStorage.getItem("Role") === "1" && acaid !== "") {
        temp.append("academy_id", acaid.value);
      }
      if (urllink === "workerdetail") {
        temp.append("id", id);
      }
      workercreate(temp).then((res) => {
        if (res.status === true) {
          setLoading(false);
          setSuccess(false);
          toast.success(res.message);
          navigate("/workers/workerlist");
        } else {
          setLoading(false);
          setSuccess(false);
          toast.error(res.message);
        }
      });
    }
  }
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <div className="page-header">
        {urllink === "workerdetail" &&
          <h2 className="main-conten-title tx-24 mg-b-5">Workers Detail</h2>

        }
        {urllink !== "workerdetail" &&
          <h2 className="main-conten-title tx-24 mg-b-5">Add Workers</h2>

        }
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Workers</a>
          </li>
          {urllink !== "workerdetail" &&
            <li className="breadcrumb-item active" aria-current="page">
              Add Workers
            </li>
          }
          {urllink === "workerdetail" &&
            <li className="breadcrumb-item active" aria-current="page">
              Workers Detail
            </li>
          }
        </ol>
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}

      {!loading && (
        <div className="content-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-lg-4">
                        <label className="form-label ">Photo</label>
                        <div className="avatar-upload">
                          <div className="avatar-preview">
                            <img
                              src={purl}
                              onError={(e) => errorphoto(e)}
                              alt="Worker"
                            />
                          </div>
                          <div className="change-btn mt-2 mb-lg-0 mb-3">
                            <input
                              type="file"
                              className="form-control"
                              accept=".png, .jpg, .jpeg"
                              onChange={(e) => photofile(e)}
                            />
                            {photoerror !== "" && (
                              <span className="text-danger">{photoerror}</span>
                            )}

                            <a
                              className="btn btn-secondary my-2"
                              onClick={() => {
                                setPUrl("");
                                setPFile("");
                              }}
                            >
                              Remove
                            </a>
                          </div>
                        </div>

                        
                      </div>
                      <div className="col-xl-9 col-lg-8">
                        <div className="row">
                          {localStorage.getItem("Role") === "1" && (
                            <div className="col-xl-6 col-sm-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Select Academy
                                  <span className="text-danger"> *</span>
                                </label>
                                <Select
                                  className="default-select"
                                  placeholder="Select Academy"
                                  value={acaid}
                                  options={alist}
                                  onChange={handleAcademy}
                                  isSearchable={true}
                                  isClearable
                                  hidden
                                />
                                {successmsg && acaid === "" && (
                                  <span className="text-danger">
                                    Please Enter Select Academy
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Worker Name
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Worker Name"
                                value={wname}
                                onChange={(e) => setWName(e.target.value)}
                                onKeyPress={LetterOnly}
                                onPaste={onPasteLetter}
                              />
                              {successmsg && wname === "" && (
                                <span className="text-danger">
                                  Please Enter Worker Name
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Employ ID<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Employ ID"
                                value={empid}
                                onChange={(e) => setEmpId(e.target.value)}
                              />
                              {successmsg && empid === "" && (
                                <span className="text-danger">
                                  Please Enter Employ ID
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Workers Type
                                <span className="text-danger"> *</span>
                              </label>
                              <select
                                className="default-select form-control wide"
                                value={wtype}
                                onChange={(e) => setWType(e.target.value)}
                              >
                                <option value="" disabled>
                                  Select Workers Type
                                </option>
                                {/* {wlist.map((item, i) => {
                                  return (
                                    <option value={item.id} key={i}>
                                      {item.type_name}
                                    </option>
                                  );
                                })} */}
                                {wlist
                                  .filter(item => item.id > 5)
                                  .map((item) => {
                                    return (
                                      <option value={item.id} key={item.id}>
                                        {item.name}
                                      </option>
                                    );
                                  })}

                              </select>
                              {successmsg && wtype === "" && (
                                <span className="text-danger">
                                  Please Select Workers Type
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Date Of Birth
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                className="form-control"
                                type="date"
                                value={wdob}
                                onChange={(e) => setWDob(e.target.value)}
                              />
                              {successmsg && wdob === "" && (
                                <span className="text-danger">
                                  Please Enter Date Of Birth
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Blood Group
                                <span className="text-danger"> *</span>
                              </label>
                              <select
                                className="default-select form-control wide"
                                value={wblood}
                                onChange={(e) => setWBlood(e.target.value)}
                              >
                                <option value="" disabled>
                                  Select Blood Group
                                </option>
                                {blist.map((data, i) => {
                                  return (
                                    <option value={data.id} key={i}>
                                      {data.name}
                                    </option>
                                  );
                                })}
                              </select>
                              {successmsg && wblood === "" && (
                                <span className="text-danger">
                                  Please Select Blood Group
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Gender<span className="text-danger"> *</span>
                              </label>
                              <select
                                className="default-select form-control wide"
                                value={wgender}
                                onChange={(e) => setWGender(e.target.value)}
                              >
                                <option value="" disabled>
                                  Select Gender
                                </option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                              </select>
                              {successmsg && wgender === "" && (
                                <span className="text-danger">
                                  Please Select Gender
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Phone Number
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Phone Number"
                                value={wphone}
                                onChange={handleChange}
                                maxLength={10}
                              />
                              {successmsg && wphone === "" && (
                                <span className="text-danger">
                                  Please Enter Phone Number
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Qualification
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Qualification"
                                value={wqual}
                                onChange={(e) => setWQual(e.target.value)}
                              />
                              {/* {successmsg && wqual === "" && (
                                <span className="text-danger">
                                  Please Enter Qualification
                                </span>
                              )} */}
                            </div>
                          </div>

                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Address 1<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Address 1"
                                value={wadd1}
                                onChange={(e) => setWAdd1(e.target.value)}
                              />
                              {successmsg && wadd1 === "" && (
                                <span className="text-danger">
                                  Please Enter Address 1
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">Address 2</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Address 2"
                                value={wadd2}
                                onChange={(e) => setWAdd2(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                State<span className="text-danger"> *</span>
                              </label>
                              <Select
                                className="default-select"
                                placeholder="Select State"
                                value={wstate}
                                options={slist}
                                onChange={handleState}
                                isSearchable={true}
                                isClearable
                                hidden
                              />

                              {successmsg && wstate === "" && (
                                <span className="text-danger">
                                  Please Select State
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                District<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter District"
                                value={wdist}
                                onChange={(e) => setWDist(e.target.value)}
                              />
                              {successmsg && wdist === "" && (
                                <span className="text-danger">
                                  Please Enter District
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                City<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Your City"
                                value={wcity}
                                onChange={(e) => setWCity(e.target.value)}
                              />
                              {successmsg && wcity === "" && (
                                <span className="text-danger">
                                  Please Enter City
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Pincode<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Pincode"
                                value={wpin}
                                onChange={(e) => setWPin(e.target.value)}
                                maxLength={6}
                              />
                              {successmsg && wpin === "" && (
                                <span className="text-danger">
                                  Please Enter Pincode
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-12">
                            <h6 className="tx-15 text-uppercase mb-3 mt-2">Bank Details</h6>
                          </div>

                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">Account Holder Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Account Holder Name"
                                value={acchold}
                                onChange={(e) => setAccHold(e.target.value)}
                                onKeyPress={LetterOnly}
                                onPaste={onPasteLetter}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">Bank Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Bank Name"
                                value={bname}
                                onChange={(e) => setBName(e.target.value)}
                                onKeyPress={LetterOnly}
                                onPaste={onPasteLetter}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">Bank Account No</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Bank Account No"
                                value={accno}
                                onChange={handleAcc}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">Bank IFSC Code</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Bank IFSC Code"
                                value={ifscode}
                                onChange={(e) => setIfsCode(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">Bank Branch</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Bank Branch"
                                value={bbranch}
                                onChange={(e) => setBBranch(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {errmsg && <span className="text-danger">{errmsg}</span>}
            <div className="res-right mt-4 mb-4 me-4">
              <button className="btn btn-success" onClick={submitworker}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
